import type {SubscriptionProductIds} from '@/types/subscriptions';
import type {ValueOf} from '@myparcel-frontend/types';
import {SubscriptionType} from '@/types/subscriptions';
import {
  isBundlesProductId,
  isMyAnalyticsProductId,
  isMyContractsProductId,
  isMyOrdersProductId,
  isMyScanAndPrintProductId,
} from '@/utils/subscriptions/productId';

export const getSubscriptionType = (productId: SubscriptionProductIds): ValueOf<typeof SubscriptionType> | null => {
  switch (true) {
    case isMyAnalyticsProductId(productId):
      return SubscriptionType.MyAnalytics;
    case isMyContractsProductId(productId):
      return SubscriptionType.MyContracts;
    case isMyOrdersProductId(productId):
      return SubscriptionType.MyOrders;
    case isMyScanAndPrintProductId(productId):
      return SubscriptionType.MyScanAndPrint;
    case isBundlesProductId(productId):
      return SubscriptionType.Bundles;
    default:
      return null;
  }
};

export const isSubscriptionTypeMyAnalytics = (type: ValueOf<typeof SubscriptionType>): boolean =>
  type === SubscriptionType.MyAnalytics;

export const isSubscriptionTypeMyOrders = (type: ValueOf<typeof SubscriptionType>): boolean =>
  type === SubscriptionType.MyOrders;

export const isSubscriptionTypeMyScanAndPrint = (type: ValueOf<typeof SubscriptionType>): boolean =>
  type === SubscriptionType.MyScanAndPrint;

export const isSubscriptionTypeMyContracts = (type: ValueOf<typeof SubscriptionType>): boolean =>
  type === SubscriptionType.MyContracts;

export const isSubscriptionTypeBundles = (type: ValueOf<typeof SubscriptionType>): boolean =>
  type === SubscriptionType.Bundles;
